// 登录组件
<template>
  <div class="login-box">
    <van-field v-if="mobileLoginStatus == 1" class="input-item" left-icon="manager" label="账号" v-model.trim="name"
      clearable placeholder="请输入您的登录名或手机号"></van-field>
    <van-field v-if="mobileLoginStatus == 1" class="input-item" label="密码" :type="isShowPW ? 'password' : ''"
      left-icon="lock" :right-icon="isShowPW ? 'closed-eye' : 'eye-o'" @click-right-icon="isShowPW = !isShowPW"
      v-model.trim="password" clearable placeholder="请输入您的密码"></van-field>
    <van-field v-if="mobileLoginStatus == 2" class="input-item" left-icon="phone" v-model.trim="mobile" label="手机号"
      clearable placeholder="请输入手机号码"></van-field>
    <van-field v-if="mobileLoginStatus == 2" class="input-item" left-icon="edit" v-model="captcha" label="图片验证"
      clearable placeholder="请输入图片验证码" style="display: flex;align-items: center;">
      <div slot="button" @click="changeCode()">
        <img v-if="captchaImage" :src="captchaImage" class="chaImage" />
      </div>
    </van-field>
    <van-field v-if="mobileLoginStatus == 2" class="input-item" v-model="code" left-icon="edit" center label="验证码"
      clearable placeholder="请输入短信验证码">
      <van-button :disabled="isDisabled" slot="button" size="small" type="primary" @click="getCode">
        {{isSpend? time + 's后重新获取':'获取验证码'}}
      </van-button>
    </van-field>
    <div class="btn-list">
      <span @click="go('getPassword')">忘记密码?</span>
      <span @click="mobileLogin">{{
        mobileLoginStatus === 1 ? "手机号码登录" : "账号密码登录"
        }}</span>
      <!-- <span>意见反馈</span> -->
    </div>
    <van-button class="loginBtn" type="primary" size="large" @click="login">登录</van-button>
    <van-button class="loginBtn" type="primary" size="large" @click="go('meetRegister')" plain>注册</van-button>
  </div>
</template>

<script>
  import { Field, Button, Toast } from "vant";
  import { getUser } from "@/api/dictionary";
  import {
    getDivisionData,
    getCommonDictionary,
    getMobileLoginCode,
    checkMobile,
    getCaptchaImage
  } from "@/api/login";
  import { mapActions, mapMutations } from "vuex";
  import { setSessionStore } from "@/utils/sessionStorage";

  export default {
    data() {
      return {
        name: "",
        password: "",
        isShowPW: true,
        screenHeightNoChange: true,
        grant_type: "password",
        mobileLoginStatus: 1,
        time: 60,
        isSpend: false,
        isDisabled: false,
        mobile: "",
        code: "",
        userInfo: {},
        memberCategory: "1",
        captcha: '',
        captchaImage: ''
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
    },
    created() {
      this.getCaptchaImageFunction()
    },
    methods: {
      ...mapActions(["securityCheck"]),
      ...mapMutations(["setMemberInfo", "setTitleList", "setAddrList"]),
      changeCode() {
        this.getCaptchaImageFunction()
      },
      go(type) {
        this.$router.push({ name: type });
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then((res) => {
            if (res.success) {
              this.userInfo = res.result;
              this.setMemberInfo(res.result);
              localStorage.setItem("userInfo",JSON.stringify(res.result))
              setSessionStore("memberId", res.result.id);
              resolve();
            } else {
              Toast("用户信息获取失败");
            }
          });
        });
      },
      mobileLogin() {
        if (this.mobileLoginStatus == 1) {
          this.mobileLoginStatus = 2;
          this.grant_type = "sms";
        } else {
          this.mobileLoginStatus = 1;
          this.grant_type = "password";
        }
      },
      getCaptchaImageFunction() {
        let captchaUuid = "";
        if (sessionStorage.getItem("captchaUuid")) {
          captchaUuid = sessionStorage.getItem("captchaUuid");
        } else {
          //生成captchaUuid
          let times = new Date().getTime();
          let numNo = Number(Math.random().toString().substr(2));
          captchaUuid = (times + numNo).toString(12);
          sessionStorage.setItem("captchaUuid", captchaUuid);
        }
        getCaptchaImage({ captchaUuid: captchaUuid }).then(res => {
          if (res.success) {
            this.$set(this, "captchaImage", res.result)
          } else {
            this.$message.error(res.message || "验证码生成失败");
          }
        })
      },
      async getCode() {
        let mobile = this.mobile;

        if (this.isSpend) {
          return;
        }

        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }
        if (!this.captcha) {
          Toast("请输入图形验证码");
          return false;
        }
        await this.checkMobiles(mobile);

        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getMobileLoginCode({
          mobile: mobile, captchaUuid: sessionStorage.getItem("captchaUuid"),
          sign: sign, timestamp: timestamp, captcha: this.captcha
        }).then((res) => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          } else {
            Toast(res.message)
          }
        });
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
      submit() {
        var params = {
          device: 'mobile',
          username: this.name,
          password: this.password,
          memberCategory: this.memberCategory,
          grant_type: this.grant_type,
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
          mobile: this.mobile,
          code: this.code,

        };
        if (!this.password.match(/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*]).{8,}$/)) {
          sessionStorage.setItem("jdmm", true)
        }
        this.securityCheck(params)
          .then((res) => {
            this.getUserInfo()
              .then((res) => {
                this.$router.push({ name: "MeetingList" });
                // this.$router.push({ name: 'fsHome' });
                // if (res.success) {
                //   // this.$router.push({ name: "userInfo" });
                //
                // }
              })
              .catch(() => {
                Toast("用户信息获取失败");
              });
          })
          .catch((res) => {
            if (this.mobileLoginStatus == 1) {
              if (res.error_description == "Internal Server Error") {
                Toast("用户名或密码错误");
              } else {
                Toast(res.error_description);
              }
            } else {
              if (res.error_description == "Internal Server Error") {
                Toast("手机号或验证码错误");
              } else {
                Toast(res.error_description);
              }
            }

          });
      },
      checkMobiles(mobile) {
        let params = {
          mobile,
        };

        return new Promise((resolve) => {
          checkMobile(params).then((res) => {
            if (!res.result && res.success) {
              Toast("该手机号码还未注册！");
            } else {
              resolve();
            }
          });
        });
      },
      login() {
        if (this.mobileLoginStatus == 2) {
          if (!this.mobile) {
            Toast("手机号不能为空");
            return;
          } else if (!this.code) {
            Toast("验证码不能为空");
            return;
          }
        } else {
          if (!this.name) {
            Toast("用户名不能为空");
            return;
          } else if (!this.password) {
            Toast("密码不能为空");
            return;
          }
        }

        this.submit();
      },
    },
    mounted() {
      getCommonDictionary("TITLE").then((res) => {
        this.setTitleList(res.result);
      });

      //获取地址
      getDivisionData().then((res) => {
        this.setAddrList(res.result);
      });
      const self = this;
      window.onresize = () => {
        if (self.oldFullHeight) {
          self.screenHeightNoChange =
            document.documentElement.clientHeight === self.oldFullHeight;
        }
      };
    },
  };
</script>

<style lang="less" scoped>
  .login-box {
    padding: 55px 0;
  }

  .input-item {
    padding: 0;
    padding-bottom: 12px;

    i {
      color: #aaa;
      margin-right: 10px;
    }

    &+.input-item {
      margin-top: 30px;
    }
  }

  .loginBtn {
    margin-top: 20px !important;
  }

  .btn-list {
    display: flex;
    margin: 30px 0;
    font-size: 14px;
    justify-content: space-between;
    color: #7d7d7d;
  }

  /deep/.van-field__label {
    width: 1.9rem
  }

  .chaImage {
    width: 90px;
    height: 30px;
    margin-left: 10px
  }
</style>